export const EVENT_TRACKING = {
  JOB_CARD_VIEW: 'job.card-view',
  JOB_CARD_EXPAND: 'job.card-expand',
  JOB_CARD_DETAILS_CLICK: 'job.card-job-details-click',
  JOB_CARD_COMPANY_CLICK: 'job.card-company-click',
  JOB_CARD_CATEGORY_CLICK: 'job.card-category-click',
  JOB_CARD_INTERACT: 'job.card-interact',
  JOB_CARD_APPLY_CLICK: 'job.card-apply-click',
  JOB_APPLY_INTERNAL_CLICK: 'job.apply-internal-click',
  JOB_APPLY_EXTERNAL_CLICK: 'job.apply-external-click',
  JOB_PAGE_DIRECT_VIEW: 'job.page-direct-view',
  COMPANY_CARD_VIEW: 'company.card-view',
  COMPANY_CARD_DETAILS_CLICK: 'company.card-details-click',
  COMPANY_CARD_CATEGORY_CLICK: 'company.card-category-click',
  COMPANY_PAGE_STORY_INTERACTION: 'company.page-story-interaction',
  COMPANY_PAGE_DIRECT_VIEW: 'company.page-direct-view',
  JOB_LISTING_VIEW: 'job-listing.view',
  JOB_LISTING_CATEGORY_CLICK: 'job-listing.category-click',
  JOB_LISTING_CARD_APPLY_CLICK: 'job-listing.card-apply-click',
  JOB_LISTING_APPLY_EXTERNAL: 'job-listing.apply-external-click',
  SEARCH_JOBS: 'search.jobs',
  SEARCH_COMPANIES: 'search.companies',
  SEARCH_VIDEOS: 'search.videos',
  CANDIDATE_CV_CLICK: 'candidate.cv-company-click',
  CANDIDATE_LINKEDIN_CLICK: 'candidate.linkedin-company-click',
  CANDIDATE_DETAILS_CLICK: 'candidate.show-details-company-click',
  VIDEO_STARTED: 'video.play-started',
  VIDEO_MOMENT_STARTED: 'video.section-play-started',
  VIDEO_PAGE_VIEW: 'video.page-view',
  VIDEO_SUMMARY_VIEW: 'video.summary-view',
  COMMUNITY_PARTNER_AD_VIEW: 'ads.community-partner-view',
  COMMUNITY_PARTNER_AD_CLICK: 'ads.community-partner-click',
  LIVE_EVENT_DETAILS_PAGE_VIEW: 'live-event.details-page-view',
  LIVE_EVENT_DETAILS_LIVE_PLAY: 'live-event.live-play',
  LIVE_EVENT_DETAILS_RECORDING_PLAY: 'live-event.recording-play',
  LIVE_EVENT_AD_VIEW: 'live-event.ad-view',
  LIVE_EVENT_AD_CLICK: 'live-event.ad-click',
  LIVE_EVENT_PARTNER_CLICK: 'live-event.partner-click',
  LIVE_EVENT_SPONSOR_CLICK: 'live-event.sponsor-click',
}

export const USER = {
  SIGNUP_STEPS: {
    REGISTRATION: 1,
    BASIC_INFO: 2,
    COMPLETED: 3
  },
  SIGNUP_TYPE: {
    DEVELOPER_V2: 1,
  },
  ACCOUNT_TYPES: {
    DEVELOPER: 'developer',
    COMPANY: 'company',
    ADMIN: 'admin',
    GENERIC: 'generic',
  },
  DEV_DIGEST_SUBSCRIPTION_STATUS: {
    UNSUBSCRIBED: 0,
    SUBSCRIBED: 1,
    NOT_SPECIFIED: 2,
  },
}

export const JOB_AD_PRICING_TYPES = {
  MEMBERSHIP: 'membership',
  REGULAR: 'regular',
  CREDIT: 'credit',
}

export const COMPANY_TYPES = {
  COMPANY: 0,
  AGENCY: 1,
}

export const EVENT_CATEGORY = {
  COFFEE_WITH_DEVS: {
    name: 'Coffee With Developers',
    slug: 'coffee-with-developers',
  },
  WAD_LIVE: {
    name: 'Live',
    slug: 'live',
  },
  CONGRESS: {
    name: 'Congress',
    slug: 'congress',
  },
  CAPPUCCINO_WITH_HR: {
    name: 'Cappuccino with HR',
    slug: 'cappuccino-with-hr',
  },
}
